import { render, staticRenderFns } from "./TableMandatos.vue?vue&type=template&id=42c566ca"
import script from "./TableMandatos.vue?vue&type=script&lang=js"
export * from "./TableMandatos.vue?vue&type=script&lang=js"
import style0 from "./TableMandatos.vue?vue&type=style&index=0&id=42c566ca&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports